import { default as LineChart } from './LineChart';
import { default as EChart } from './Echart';

const Chart = {
  LineChart,
  EChart,
};

export default Chart;
